import { render, staticRenderFns } from "./exchangePointIncome.vue?vue&type=template&id=e2b6d96a&"
import script from "./exchangePointIncome.vue?vue&type=script&lang=js&"
export * from "./exchangePointIncome.vue?vue&type=script&lang=js&"
import style0 from "./exchangePointIncome.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports